import { FC } from 'react';
import { Clock } from 'lucide-react';

export const AvailabilityInfoCard: FC = () => {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 flex items-start gap-3">
      <Clock className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
      <div className="text-sm text-blue-800 dark:text-blue-200">
        <p className="font-medium mb-1">How availability works</p>
        <p className="text-blue-600 dark:text-blue-300">
          Toggle each day on or off, then set your working hours. Clients can only book appointments
          during your available hours. These settings repeat weekly.
        </p>
      </div>
    </div>
  );
};
